import { render, staticRenderFns } from "./RziScoresList.vue?vue&type=template&id=f7526ac0&scoped=true&"
import script from "./RziScoresList.vue?vue&type=script&lang=js&"
export * from "./RziScoresList.vue?vue&type=script&lang=js&"
import style0 from "./RziScoresList.vue?vue&type=style&index=0&id=f7526ac0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7526ac0",
  null
  
)

export default component.exports